import { render, staticRenderFns } from "./adjusted-stock.vue?vue&type=template&id=0a146366&scoped=true"
import script from "./adjusted-stock.vue?vue&type=script&lang=js"
export * from "./adjusted-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a146366",
  null
  
)

export default component.exports